// the play lifted above the review modal backdrop, shared between the checkout and the play list
export const useEditorSpotlight = () => useState<Maybe<string>>('editor-spotlight', () => null)
